import { render, staticRenderFns } from "./PapaSettingsSection.vue?vue&type=template&id=b4937f98&scoped=true&"
import script from "./PapaSettingsSection.vue?vue&type=script&lang=ts&"
export * from "./PapaSettingsSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4937f98",
  null
  
)

export default component.exports